module.exports = __webpack_public_path__ + "static/media/Logo-Google.6f14c86c.png";